<template>
    <div id="hPa_control" 
        class="hPa-control"
    >
        <div class="slider-title">
            <span class="slider-title__text">hPa</span>
        </div>
        <v-slider
            v-model="hPa_index"
            :max="hPa_sliders.length - 1"
            ticks="always"
            :tick-labels="hPa_sliders"
            hide-details
            @change="set_dropsonde({ hPa: hPa_sliders[hPa_index] })"
        />
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    export default {
        name: 'hPaControl',

        data() {
            return {
                hPa_sliders: [200, 300, 400, 500, 700, 850, 925, 'all'],
                hPa_index: null
            }
        },

        mounted() {
            this.hPa_index = this.hPa_sliders.length
        },

        methods: {
            ...mapMutations('emap', [
                'set_dropsonde'
            ]),
        },
    }
</script>

<style lang="scss" scoped>
    .hPa-control {
        font-size: 12px;
    }

    .slider-title {
        margin-bottom: 1rem;

        &__text {
            transform: translateX(-.25rem);
            display: inline-block;
            font-size: .75rem;
            letter-spacing: .5px;
            line-height: 1.33;
        }
    }
</style>

<style scoped>
    .hPa-control >>> .v-slider__tick {
        top: calc(50% - .1875rem) !important;
        height: .375rem !important;
        background-color: #fff;
    }

    .hPa-control >>> .v-slider__tick-label {
        top: -1.5rem;
        font-size: .75rem;
        letter-spacing: .5px;
        line-height: 1.33;
        text-align: center;
    }

    .hPa-control >>> .v-slider__tick:first-child .v-slider__tick-label,
    .hPa-control >>> .v-slider__tick:last-child .v-slider__tick-label {
        transform: translateX(-50%);
    }

    .hPa-control >>> .v-slider__track-fill {
        background-color: #fff !important;
    }

    .hPa-control >>> .v-slider__track-background.v-slider__track-background {
        /* 重複兩次 .v-slider__track-background 是為了加高權重 */
        background-color: #fff !important;
    }

    .hPa-control >>> .v-slider__thumb {
        left: initial;
        transform: translate(-50%, -50%);
        width: 1rem;
        height: 1rem;
        background-color: #fff !important;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, .5);
    }

    .hPa-control >>> .v-slider__thumb::before {
        content: none;
    }
</style>

